import NextLink, { LinkProps as _LinkProps } from 'next/link';
import React, { AnchorHTMLAttributes } from 'react';

export interface LinkProps
  extends Omit<
      _LinkProps,
      'passHref' | 'onClick' | 'onMouseEnter' | 'onTouchStart'
    >,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  className?: string;
  children?: React.ReactNode;
  state?: unknown;
}

function LinkIntrinsic(
  props: LinkProps,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref: React.Ref<HTMLAnchorElement>,
): React.ReactElement {
  const {
    className,
    children,
    href,
    as,
    replace,
    scroll,
    shallow,
    prefetch,
    locale,
  } = props;
  const nextLinkProps = {
    replace,
    scroll,
    shallow,
    prefetch,
    locale,
  };

  return (
    <NextLink
      ref={ref}
      className={className}
      {...nextLinkProps}
      href={href ?? ''}
      as={as ?? href}
      passHref
    >
      {children}
    </NextLink>
  );
}

export const Link = React.memo(React.forwardRef(LinkIntrinsic));
